import { highlight } from '../variants/highlight';

export const highlighter = {
  '.highlight-ai': highlight.ai,
  '.highlight-default': highlight.default,
  '.highlight-search': highlight.search,
};
